module.exports = __webpack_public_path__ + "img/logo.9e319250.svg";